export default __webpack_public_path__ + "static/media/map.c475cf1a.png";